interface MessageDisplayingProps {
  bubblePaletteColor: 'primary' | 'secondary'
  direction: 'incoming' | 'outgoing'
}

export const getMessageDisplayingProps = (isCareteamMessage: boolean): MessageDisplayingProps => ({
  bubblePaletteColor: isCareteamMessage ? 'secondary' : 'primary',
  direction: isCareteamMessage ? 'outgoing' : 'incoming',
})
